module.exports = __webpack_public_path__ + "static/media/Shoppie.3c9e3257.svg";